import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType, CodeBlock, BlockType, ValidationMessage, ValidationMessageType, TibboDataType,
    SettingState,
} from '@appblocks/codegeneration/types';
import * as micropython from './micropython';
import * as tios from './tios';
import * as zephyr from './zephyr';
import * as simulator from './simulator';

export default class MQTTTopic extends BaseFeature {
    constructor() {
        super();
        this.name = 'MQTT Topic';
        this.id = 'mqtt_topic';
        this.singleInstance = false;
        const settings = [
            {
                id: 'TOPIC_NAME',
                name: 'Topic Name',
                settingType: SettingType.STRINGVARIABLE,
                dataType: TibboDataType.STRING,
                max: 255,
                required: true,
                default: 'T',
            },
            {
                id: 'NAME',
                name: 'Description',
                settingType: SettingType.STRING,
                required: true,
                default: 'Example Topic',
            },
            {
                id: 'QOS',
                name: 'Quality of Service',
                settingType: SettingType.OPTION,
                required: true,
                default: 'QOS_AT_MOST_ONCE',
                options: [
                    {
                        name: 'QOS_AT_MOST_ONCE',
                        value: 'QOS_AT_MOST_ONCE',
                    },
                    {
                        name: 'QOS_AT_LEAST_ONCE',
                        value: 'QOS_AT_LEAST_ONCE',
                    },
                    {
                        name: 'QOS_EXACTLY_ONCE',
                        value: 'QOS_EXACTLY_ONCE',
                    },
                ],
            },
        ];
        this.settings = this.settings.concat(settings);
    }

    initSettings(project?: any, parentFeature?: any): void {
        super.initSettings(project, parentFeature, 'TOPIC_NAME');
    }

    getState(settingId: string): SettingState {
        if (settingId === 'QOS' && this.project.runtime === 'micropython') {
            return SettingState.DISABLED;
        }
        return super.getState(settingId);
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }
}
